var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "build-tools/webpack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "build-tools/webpack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    stroke: "#1C78C0",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "e0b5805d423a4ec9473ee315250968b2",
    transform: "translate(11.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "23.2495466 0 46.4990932 13.1507125 46.4990932 39.4581452 23.2495466 52.6088577 0 39.4581452 0 13.1507125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3478175,38.5509923 L24.0185238,48.92017 L24.0185238,40.8459088 L35.4390375,34.5619229 L42.3478175,38.5509923 Z M43.6034132,37.4155494 L43.6034132,15.7339955 L36.8988928,19.6089199 L36.8988928,33.5466326 L43.6034132,37.4155494 Z M4.07918401,38.5509923 L22.4084777,48.92017 L22.4084777,40.8459088 L10.9819564,34.5619229 L4.07918401,38.5509923 Z M2.82358834,37.4155494 L2.82358834,15.7339955 L9.52810875,19.6089199 L9.52810875,33.5466326 L2.82358834,37.4155494 Z M3.6105885,14.3282089 L22.4084777,3.69469539 L22.4084777,11.498613 L10.36317,18.1250341 L10.2670478,18.1791028 L3.6105885,14.3282089 Z M42.816413,14.3282089 L24.0185238,3.69469539 L24.0185238,11.498613 L36.0638316,18.1190265 L36.1599537,18.1730952 L42.816413,14.3282089 Z",
    id: "Shape",
    fill: "#8ED6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4084777,39.0075726 L11.1381549,32.8076935 L11.1381549,20.5340957 L22.4084777,27.0403641 L22.4084777,39.0075726 Z M24.0185238,39.0075726 L35.2888467,32.8137011 L35.2888467,20.5340957 L24.0185238,27.0403641 L24.0185238,39.0075726 Z M11.9011245,19.1162939 L23.2135008,12.8983919 L34.525877,19.1162939 L23.2135008,25.6465929 L11.9011245,19.1162939 Z",
    id: "Shape",
    fill: "#1C78C0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpack);
export default __webpack_public_path__ + "static/media/webpack.8ead3b3745631a035d09af493c8ccc9c.svg";
export { ForwardRef as ReactComponent };